import styled from 'styled-components';

export const MultidayWarningMessageContainer = styled.div`
  color: ${({ theme }) => theme.colors.greys.adminGreyDark};
  font-size: 14px;
  margin-bottom: 10px;
`;
